import type { Link } from '@components/models';
import React from 'react';

import './style.scss';

type Props = {
    title?: string;
    link?: Link;
};

const HeaderContentCarousel = ({ link, title }: Props) => {
    return (
        <div className="header-content-carousel">
            <h2 data-testid="header-content-carousel__title">{title}</h2>
            {link && link.url_path && link.extra_text_for_link && (
                <a data-testid="header-content-carousel__cta" href={link.url_path} style={{ color: link.bg_text }}>
                    {link.extra_text_for_link}
                </a>
            )}
        </div>
    );
};

export default HeaderContentCarousel;
